// src/components/relatorios/BotaoFaturamento.js
import React from 'react';
import {useHttpClient} from '../hooks/useHttpClient';
import {usePreventDoubleClick} from '../hooks/usePreventDoubleClick';
import {useNotificacoes} from '../hooks/useNotificacoes';

/**
 * Gera e baixa o PDF de faturamento.
 *
 * @param {Object}   props
 * @param {Object}   props.filtros  { idUsina, idCliente|null, mes, ano }
 * @param {Number[]} props.idsConsumo (array ou null) – opcional
 * @param {String}   props.className classes extras
 * @param {ReactNode} props.children  ícone ou texto do botão
 */
function BotaoFaturamento({
                              filtros,
                              idsConsumo = null,
                              className = '',
                              children
                          }) {
    const {post} = useHttpClient();
    const {exibirErro, exibirSucesso} = useNotificacoes();
    const [safeGerar, isGerando] = usePreventDoubleClick(gerarFaturamento);

    async function gerarFaturamento() {
        try {
            const body = {
                idsConsumo,
                usinaId: filtros.idUsina,
                clienteId: filtros.idCliente || null,
                mes: filtros.mes,
                ano: filtros.ano
            };

            const res = await post(
                '/hello-sol/faturamentos-usina/pdf',
                body,
                {responseType: 'blob', fullResponse: true}
            );

            const contentType = res.headers.get('content-type') ||
                res.headers.get('Content-Type') ||
                '';
            // se não for PDF, é JSON de erro!
            if (!contentType.includes('application/pdf')) {
                // converte o blob para texto e depois para JSON
                const text = await res.blob().then(b => b.text());
                let err;
                try {
                    err = JSON.parse(text);
                } catch {
                    err = {message: text};
                }
                throw new Error(err.message || 'Erro ao gerar fatura');
            }
            // extração robusta do filename
            const cd = res.headers.get('content-disposition') || '';
            let filename = `faturamento_${filtros.mes}_${filtros.ano}.pdf`;
            let match = cd.match(/filename\*\s*=\s*(?:UTF-8'')?["']?([^;"']+)["']?/i);
            if (!match) {
                match = cd.match(/filename\s*=\s*["']?([^;"';]+)["']?/i);
            }
            if (match && match[1]) {
                filename = decodeURIComponent(match[1]);
            }
            // é PDF: baixa o blob
            const blob = await res.blob();
            if (!blob || blob.size === 0) {
                throw new Error('Arquivo PDF vazio');
            }

            const objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(objectUrl);

            exibirSucesso('Faturamento gerado com sucesso');

        } catch (err) {
            exibirErro(err.message || 'Falha ao gerar o faturamento. ');
        }
    }

    return (
        <button
            type="button"
            className={className}
            onClick={safeGerar}
            disabled={isGerando}
            title={"Download do arquivo em PDF."}
            style={{
                background: 'none', border: 'none', padding: 0,
                color: '#0d6efd', cursor: isGerando ? 'wait' : 'pointer'
            }}
        >
            {isGerando ? '…' : children}
        </button>
    );
}

export default BotaoFaturamento;